import O1HD from "../../../../../engines/gameEngine";
import NormalGameManager from "../../../manager/NormalGameManager";
import gameConfig from "../../../../../engines/configs/gameConfig";
import LotteryCenterV2Prefab from "./LotteryCenterV2Prefab";
import {getRandomGoldHongPrize} from "../config/HongGoldPrizeConfig";
import {HongPrizeEntity} from "./LotteryGGLV2Prefab";
import {getNewGglPrize} from "../config/NewGglPrizeConfig";
import utilsModel from "../../../../../engines/libs/utilsModel";
const {ccclass, property} = cc._decorator;


@ccclass
export default class LotteryGGLV2Prefab extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;
    @property({type:cc.Label,displayName:"价格"})
    lbPrize : cc.Label = null;
    @property({type:cc.Node,displayName:"购买按钮"})
    purchaseBtnNode : cc.Node = null;
    @property({type:cc.Node,displayName:"广告购买按钮"})
    adPurchaseBtnNode : cc.Node = null;

    mGameLayer : NormalGameManager;
    private mParentScript : LotteryCenterV2Prefab;

    onLoad () {
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{ easing:cc.easing.backOut }).start();
    }

    start () {

    }

    /**
     * 绑定数据
     * @param parentScript
     */
    bindData( parentScript : LotteryCenterV2Prefab ){
        this.mParentScript = parentScript;
        this.mGameLayer = NormalGameManager._instance;
        if ( !this.mGameLayer.getGameData().lotteryInfo ) {
            //初始化数据
            this.mGameLayer.getGameData().lotteryInfo = { gglValidCount : 0 , hjGGLValidCount : 0 ,currGGLPurchaseCount : 0 , currGJGGLPurchaseCount:0,currSuperGGLPurchaseCount:0 ,currNewGGLPurchaseCount : 0};
            this.mGameLayer.writeGameData();
        }
        this.refreshBtn();
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.mParentScript && this.mParentScript.refreshBtn();
        this.node.destroy();
        this.node.removeFromParent();
    }

    /**
     * 获取当前奖项
     */
    getPrize(  ) : HongPrizeEntity{
        let randomPrizeEntity : HongPrizeEntity = getNewGglPrize() as HongPrizeEntity ;
        let prizeRate = gameConfig.NEW_GGL_NORMAL_WEIGHT ;
        let randomPrizeNum : number = Math.floor( Math.random() * 10000 * prizeRate );
        if ( randomPrizeNum <= randomPrizeEntity.weight ) {
            randomPrizeEntity.flag = true;
        }else{
            randomPrizeEntity.flag = false;
        }
        return  randomPrizeEntity;
    }

    /**
     * 购买
     */
    onBtnPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let needPayPrice : number = 10000;
        if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
        this.currOpenCount = 0;
        this.mGameLayer.getGameData().lotteryInfo.currNewGGLPurchaseCount ++;
        this.mGameLayer.writeGameData();
        this.refreshBtn();
        O1HD.emit("LuckNewGGLNode.reset");
    }


    /**
     * 广告购买
     */
    onBtnAdPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.currOpenCount = 0;
            this.refreshBtn();
            O1HD.emit("LuckNewGGLNode.reset");
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"彩票解锁");
    }


    private currOpenCount : number = 0;
    openPrize(){
        this.currOpenCount ++;
    }

    /**
     * 刷新按钮
     */
    refreshBtn(  ){
        this.purchaseBtnNode.active = true;
        let lotteryInfo = this.mGameLayer.getGameData().lotteryInfo;
        if ( lotteryInfo  ) {
            if ( lotteryInfo.currNewGGLPurchaseCount >= gameConfig.NEW_GGL_CURR_LIMIT ) {
                this.adPurchaseBtnNode.active = true;
            }else{
                this.adPurchaseBtnNode.active = false;
            }
        }else {
            this.adPurchaseBtnNode.active = false;
        }
    }
}

